import { useEffect, useRef, useState } from "react";
import { Each } from "../common/Each";
import FeedCard from "../components/cards/FeedCard";
import FeedInputCard from "../components/cards/FeedInputCard";
import styles from "./ModuleFeed.module.css";

const ModuleFeed = ({ feed = [], moduleId, prefetchedLessons, loading = false, onChange = () => { }, onScrollEnd = () => { } }) => {

  const endFeedRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {

      if (endFeedRef.current) {
        const rect = endFeedRef.current.getBoundingClientRect();
        const isVisible = (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
        setIsVisible(isVisible);
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Initial check on component mount
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      onScrollEnd();
    }
  }, [isVisible])

  return (
    <div className={styles.container}>
      <FeedInputCard moduleId={moduleId} prefetchedLessons={prefetchedLessons} onChange={onChange} />
      <Each of={feed} render={(activity, index) => {
        return (
          <FeedCard activity={activity} onChange={onChange} />
        )
      }} />
      {loading &&
        <FeedCard activity={{ loading: true }} onChange={onChange} />
      }
      <div ref={endFeedRef} style={{ visibility: 0 }} />
    </div>
  );
};

export default ModuleFeed;
